module.exports = __webpack_public_path__ + "static/media/instagram-social-media-svgrepo-com (1).189356ee.svg";